import {
  AlarmIcon,
  CameraIcon,
  Box as DarkBox,
  DoorIcon,
} from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'

import {
  FLOOR_PLAN_DEVICE_GLYPH_SIZE_RATIO,
  FloorPlanColorScheme,
  getFloorPlanVisualColors,
} from '../../utils/floorPlanVisuals'

interface DarkFloorPlanDeviceMarkerIProps {
  colorScheme: FloorPlanColorScheme
  deviceType: DeviceType
  size?: number
}

interface DeviceGlyphIProps {
  color: string
  deviceType: DeviceType
  size: number
}

const DeviceGlyph = ({ color, deviceType, size }: DeviceGlyphIProps) => {
  if (deviceType === DeviceType.Alarm) {
    return <AlarmIcon color={color} size={size} />
  }
  if (deviceType === DeviceType.Door) {
    return <DoorIcon color={color} size={size} />
  }
  return <CameraIcon color={color} size={size} />
}

export const DarkFloorPlanDeviceMarker = ({
  colorScheme,
  deviceType,
  size = 40,
}: DarkFloorPlanDeviceMarkerIProps) => {
  const colors = getFloorPlanVisualColors(colorScheme)
  const glyphSize = size * FLOOR_PLAN_DEVICE_GLYPH_SIZE_RATIO

  return (
    <DarkBox
      alignItems='center'
      bg={colors.markerBackground}
      borderColor={colors.markerRing}
      borderRadius='full'
      borderStyle='solid'
      borderWidth='2px'
      data-testid='DarkFloorPlanDeviceMarker'
      display='flex'
      flexShrink={0}
      height={`${size}px`}
      justifyContent='center'
      width={`${size}px`}
    >
      <DeviceGlyph
        color={colors.markerGlyph}
        deviceType={deviceType}
        size={glyphSize}
      />
    </DarkBox>
  )
}
